import {
  type UserDocumentPosition,
  type UserDocumentPositionERx,
  type UserOrderResponseWithFlagsSubOrdersInner,
  type UserSubOrderV2,
} from '@redteclab/api/clients/bully'

export const userSubOrderAccessorGetSubOrderProducts = (
  subOrder: UserOrderResponseWithFlagsSubOrdersInner | UserSubOrderV2,
): (UserDocumentPosition | UserDocumentPositionERx)[] => {
  const { orderDocuments, orderDocumentsERx } = subOrder

  const regularProducts =
    orderDocuments?.flatMap(
      (orderDocument) => orderDocument.documentPositions ?? [],
    ) ?? []

  const erxProducts =
    orderDocumentsERx?.flatMap(
      (orderDocumentERx) => orderDocumentERx.documentPositions ?? [],
    ) ?? []

  const allItems = [...regularProducts, ...erxProducts]

  return allItems
}
